import { FC } from 'react'

import PlayIcon from 'src/Assets/Svg/play.svg?react'

import {
  Cover,
  CoverImage,
  CoverNameWrapper,
  Name,
  PlayOverlay,
} from './styles'

export interface MediaCoverCellProps {
  name: string
  cover?: string
  onClick?: () => void
}

export const MediaCoverCell: FC<MediaCoverCellProps> = ({
  name,
  cover,
  onClick,
}) => (
  <CoverNameWrapper $clickable={Boolean(onClick)} onClick={onClick}>
    <Cover>
      {cover && <CoverImage src={cover} alt={name} />}
      <PlayOverlay>
        <PlayIcon />
      </PlayOverlay>
    </Cover>
    <Name>{name}</Name>
  </CoverNameWrapper>
)
